export default class Warning {
  constructor(warning) {
    this.warning = warning
  }

  get isPastDates() {
    return this.warning.code === 'past_dates'
  }

  get isNoticePeriodPolicyWarning() {
    return (
      this.warning.code === 'leave_request_notice_period_policy_warning' &&
      this.warning.warning_type === 'violation'
    )
  }

  get violationReason() {
    return this.warning.violation_reason
  }

  get noticePeriodDays() {
    return this.warning.notice_period_days
  }

  get leaveTypeName() {
    return this.warning.leave_type_name
  }

  get ownerName() {
    return this.warning.owner_name
  }

  get noticePeriodPolicyWarningText() {
    if (!this.isNoticePeriodPolicyWarning) return ''

    if (this.violationReason === 'past_date') {
      return `This leave starts is in the past. ${this.ownerName} can't submit this request themselves, but you can submit it on their behalf.`
    }

    return `This leave starts in less than the required notice period (${this.noticePeriodDays} days). ${this.ownerName} can't submit this request themselves, but you can submit it on their behalf.`
  }

  get isNoticePeriodPolicyPlanLimitation() {
    return (
      this.warning.code === 'leave_request_notice_period_policy_warning' &&
      this.warning.warning_type === 'plan_limitation'
    )
  }

  get requiredPlan() {
    return this.warning.required_plan
  }

  get isAdmin() {
    return this.warning.is_admin
  }

  get noticePeriodPolicyPlanLimitationText() {
    if (!this.isNoticePeriodPolicyPlanLimitation) return ''

    if (this.isAdmin) {
      return `Notice period policies have been set up, but they aren't currently applied because your plan doesn't include this feature. Upgrade to ${this.requiredPlan} to enable them, or remove the policies.`
    }

    return `Notice period policies have been set up, but they aren't currently applied because your plan doesn't include this feature.`
  }

  get isMaximumLeaveRequestPolicyWarning() {
    return (
      this.warning.code === 'maximum_leave_request_policy_warning' &&
      this.warning.warning_type === 'violation'
    )
  }

  get dayCount() {
    return this.warning.day_count
  }

  get maxDays() {
    return this.warning.max_days
  }

  get countType() {
    return this.warning.count_type
  }

  get countTypeLabel() {
    return this.countType === 'working_days' ? 'working' : 'calendar'
  }

  get maximumLeaveRequestPolicyWarningText() {
    if (!this.isMaximumLeaveRequestPolicyWarning) return ''

    return (
      `${this.ownerName} would not be allowed to make this request (${this.dayCount} ${this.countTypeLabel} days ` +
      `exceeds the maximum of ${this.maxDays}), but you can make it on their behalf.`
    )
  }

  get isMaximumLeaveRequestPolicyPlanLimitation() {
    return (
      this.warning.code === 'maximum_leave_request_policy_warning' &&
      this.warning.warning_type === 'plan_limitation'
    )
  }

  get maximumLeaveRequestPolicyPlanLimitationText() {
    if (!this.isMaximumLeaveRequestPolicyPlanLimitation) return ''

    if (this.isAdmin) {
      return `Maximum leave request policies have been set up, but they aren't currently enforced because your plan doesn't include this feature. Upgrade to ${this.requiredPlan} to enable them.`
    }

    return `Maximum leave request policies have been set up, but they aren't currently enforced because your plan doesn't include this feature.`
  }

  get isBookingPeriodPolicyOnBehalfWarning() {
    return (
      this.warning.code ===
      'leave_request_booking_period_policy_on_behalf_warning'
    )
  }

  get bookingPeriodPolicyOnBehalfWarningText() {
    if (!this.isBookingPeriodPolicyOnBehalfWarning) return ''

    return this.warning.message
  }

  get isBookingPeriodPolicyPlanLimitation() {
    return (
      this.warning.code ===
      'leave_request_booking_period_policy_plan_limitation_warning'
    )
  }

  get bookingPeriodPolicyPlanLimitationText() {
    if (!this.isBookingPeriodPolicyPlanLimitation) return ''

    return this.warning.message
  }
}
